var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-list"},_vm._l((_vm.filteredList),function(item,index){return _c('data-list-item',{key:index,attrs:{"item":item,"emptyText":_vm.emptyText}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }